import RoundedButton, { ColorStyle } from 'components/RoundedButton';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { useEffect, useState } from 'react';
import { Input, Message } from 'semantic-ui-react';
import { doABTest } from 'utils/analytics/abtest';
import { trackEvent } from 'utils/analytics/analytics';
import { getCookie } from 'utils/cookie';
import { renderReward } from '../payment-section/renderReward';
import { observer } from 'mobx-react-lite';

export const PromoCodeEntry = observer(() => {
  const {
    currentPromo,
    promoErrorMessage,
    setPromoCode,
    isPaidSubscription,
    isCurrentPromoFirstEntryDiscount,
    initialised_promocode,
  } = useEnterStore();
  const [promoCodeStr, setPromoCodeStr] = useState(
    initialised_promocode && !isCurrentPromoFirstEntryDiscount
      ? localStorage.getItem('promoCode') || getCookie('promo_code') || ''
      : ''
  );
  const [showPromoCodeSection, setShowPromoCodeSection] = useState(
    !!promoCodeStr && !isPaidSubscription
  );

  const [applyPromoCodeLoading, setApplyPromoCodeLoading] = useState(false);

  useEffect(() => {
    const ShowExtendedPromoCode = doABTest('ShowExtendedPromoCode', ['Y', 'N']);

    if (ShowExtendedPromoCode === 'N') {
      return;
    }
    setShowPromoCodeSection(true);
  }, []);

  return showPromoCodeSection ? (
    <>
      {currentPromo &&
      !isCurrentPromoFirstEntryDiscount &&
      !promoErrorMessage ? (
        renderReward(currentPromo)
      ) : (
        <>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center',
            }}
          >
            <Input
              placeholder="Enter promo code"
              type="text"
              autoComplete="off"
              autoCorrect="off"
              onChange={(e) => {
                setPromoCodeStr(e.target.value);
              }}
              className="neonInput"
              style={{
                borderRadius: '3px',
                fontSize: '15px', // Don't zoom in on iOS
              }}
              value={promoCodeStr}
            />

            <RoundedButton
              onClick={async () => {
                setApplyPromoCodeLoading(true);
                await setPromoCode(promoCodeStr);
                localStorage.setItem('promoCode', promoCodeStr);
                setApplyPromoCodeLoading(false);
                trackEvent('Set Promo Code', { promoCodeStr });
              }}
              style={{
                marginLeft: '10px',
                paddingTop: '12px',
              }}
              loading={applyPromoCodeLoading}
              colorStyle={ColorStyle.Primary}
              href={undefined}
              className={undefined}
              id={undefined}
              disabled={
                promoCodeStr.trim().length === 0 || applyPromoCodeLoading
              }
              hoverColor={undefined}
              hoverTextColor={undefined}
            >
              Use Code
            </RoundedButton>
              
          </div>
            {promoErrorMessage && <Message negative header={promoErrorMessage} style={{ margin: 0 }} />}
        </>
      )}
    </>
  ) : (
    <p
      onClick={() => {
        setShowPromoCodeSection(true);
        trackEvent('Open Promo Code Section');
      }}
      style={{ color: '#9B9B9B' }}
      className="hover:cursor-pointer text-center italic"
    >
      Got a code?
    </p>
  );
});
